import leylaPic from "@/public/images/artists/leyla.jpg";
import { Artist } from "@/types/types";

export const leyla = {
  id: "290",
  name: "Leyla",
  image: leylaPic,
  description: `Leyla has a soft, expressive voice with a bright tone, agile delivery, and a confident, rhythmic presence.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fleyla-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Unprocessed", "Soul", "Dance", "Pop", "RnB"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 54,
        high: 68,
      },
      sweetSpot: 61,
    },
  },
} as const satisfies Artist;
